module.exports = __webpack_public_path__ + "0421197341953e907c139dbab3e57a04.fbx";